import BlogComponent from 'components/marketingSite/talentEngineV3/blog/BlogComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import WPService from 'services/wp-te.service';
import { APP_URLS } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { avoidRateLimit } from 'utils/rate-limit';
import {
  WP_REST_API_Categories,
  WP_REST_API_Posts,
  WP_REST_API_Tags
} from 'wp-types';

type TalentEngineBlogPageProps = {
  posts?: WP_REST_API_Posts;
  tags: WP_REST_API_Tags;
  categories?: WP_REST_API_Categories;
  totalPosts: number;
  totalPages: number;
};

const TalentEngineBlogPage: React.FC<TalentEngineBlogPageProps> = (props) => {
  const { t } = useI18n('talent-engine-blog');

  usePageTrack('Blog - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('talent-engine-blog.pageTitle')}
        desc={t('talent-engine-blog.page_description')}
        imgUrl={getPublicPath('/images/card_blog.png')}
        url={APP_URLS.talentEngineBlog}
        indexable={true}
      />
      <BlogComponent {...props} currentPage={0} />
    </>
  );
};

export default TalentEngineBlogPage;

export const getStaticProps: GetStaticProps<
  TalentEngineBlogPageProps
> = async ({ locale }) => {
  await avoidRateLimit();
  const responsePosts = await WPService.getPosts({
    locale: locale || 'en'
  });

  await avoidRateLimit();
  const tags = await WPService.getTags(locale || 'en');
  const categories = (await WPService.getCategories(locale || 'en')).filter(
    (c) =>
      c.count > 0 &&
      c.slug !== 'uncategorized' &&
      c.slug !== 'uncategorised' &&
      c.slug !== 'oculto' &&
      c.slug !== 'sin-categorizar' &&
      c.slug !== 'all' &&
      c.slug !== 'todo-el-blog'
  );

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'talent-engine-landing-v3',
        'talent-engine-blog'
      ])),
      posts: responsePosts?.data,
      totalPosts: Number(responsePosts?.headers.get('x-wp-total') || ''),
      totalPages: Number(responsePosts?.headers.get('x-wp-totalpages') || ''),
      categories,
      tags
    },
    revalidate: 10
  };
};
